import axios from "axios";

export default {
    namespaced: true,
    state: {
        currentMixologist: {},
        real_url: "https://abmcocktailpro.com", // without last slash
        api_url: "https://abmcocktailpro.com/api/"
    },
    mutations: {

    },
    actions: {
       getMixologist(store,id){
        // store.state.currentMixologist = preloaded.mixologists[0]
        axios.get(store.state.api_url + "get-data")
                    .then((response) => {
                        store.state.currentMixologist = response.data.mixologists[id - 1];
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
                    .finally(function () {
                        // always executed
                    })
       }
    },
    getters: {}
}
